// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * @private
 */
export const scrollbarStyles = {
  '::-webkit-scrollbar, *::-webkit-scrollbar': {
    width: '0.3rem',
    height: '0.3rem'
  },
  '::-webkit-scrollbar-thumb, *::-webkit-scrollbar-thumb': {
    borderRadius: '10px',
    background: 'rgba(150, 150, 150)'
  }
};